import { OnboardingPillButton } from "@/features/onboarding/components/onboarding-pill-button";
import { OnboardingStepShellV5 } from "@/features/onboarding/components/onboarding-step-shell-v5";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { triggerHaptic } from "@/utils/haptics";

const GRAPH_IMG = "/assets/images/onboarding-v5/fat-loss-graph.svg";

const FatLossPage = () => {
  const { navigateToNextStep } = useStepRouteInfo();

  const handleContinue = () => {
    triggerHaptic();
    navigateToNextStep();
  };

  return (
    <OnboardingStepShellV5
      title={
        <>
          <strong>Your weight will fluctuate.</strong>
        </>
      }
      subtitle={
        <>
          I'll help you to see the bigger picture and reassure you of your progress.
        </>
      }
      footer={<OnboardingPillButton text="Continue" onClick={handleContinue} />}
    >
      <div className="-mx-4 pt-2">
        <img src={GRAPH_IMG} alt="" className="w-full" />
      </div>
    </OnboardingStepShellV5>
  );
};

export default FatLossPage;
